import { useRef, useEffect, useState } from 'react';

export function useLeftAnchoredModal() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isReady, setIsReady] = useState(false);
  
  useEffect(() => {
    if (containerRef.current) {
      setIsReady(true);
    }
  }, []);
  
  return { containerRef, isReady };
}
